import * as React from 'react'
import gql from 'graphql-tag'
import Link from 'next/link'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import {
  NewsItemOrderField,
  OrderDirection,
  useGqlChannelSearchAllTabQuery,
} from 'generated/graphql'
import SearchResultHeader from '@app.components/SearchResultHeader'
import ChannelList from '@app.feature/channel/component/lists/ChannelList'
import NewsList from '@app.feature/channel/component/lists/NewsList'

gql`
  query gqlChannelSearchAllTab(
    $newsItemFilterBy: NewsItemFeedFilter
    $newsItemFeedOrderBy: NewsItemOrder
    $newsItemFeedFirst: Int
    $newsItemFeedafter: String
    $channelFeedFilterBy: ChannelFilter
    $channelFeedOrderBy: ChannelOrder
    $channelFeedfirst: Int
  ) {
    newsItemFeed(
      filterBy: $newsItemFilterBy
      orderBy: $newsItemFeedOrderBy
      first: $newsItemFeedFirst
      after: $newsItemFeedafter
    ) {
      ...NewsItemFeedList_newsItemConnection
    }
    channelFeed(
      filterBy: $channelFeedFilterBy
      orderBy: $channelFeedOrderBy
      first: $channelFeedfirst
    ) {
      ...FollowList_ChannelConnection
    }
  }
`

const ChannelSearchAll: React.FC = () => {
  const router = useRouter()
  const query = `${router.query.q || ``}`

  const variables = {
    channelFeedFilterBy: {
      q: query,
    },
    newsItemFilterBy: {
      q: query,
    },
    newsItemFeedOrderBy: {
      direction: OrderDirection.DESC,
      field: NewsItemOrderField.CREATED_AT,
    },
    channelFeedfirst: 3,
    newsItemFeedFirst: 3,
  }

  const { data, loading } = useGqlChannelSearchAllTabQuery({
    variables: {
      ...variables,
    },
  })

  return (
    <StyledWrapper>
      <SearchResultHeader>
        채널{' '}
        {data?.channelFeed?.totalCount
          ? `${data?.channelFeed.totalCount}건`
          : ``}
      </SearchResultHeader>
      <ChannelList
        data={data?.channelFeed?.edges || []}
        loading={loading}
        skeletonSize={3}
      />
      {(data?.channelFeed?.totalCount || 0) > 3 && (
        <Link
          href={{
            query: {
              ...router.query,
              tab: 'channel',
            },
          }}
        >
          <a className="more-button">채널 검색 결과 모두 보기</a>
        </Link>
      )}

      <SearchResultHeader>
        소식{' '}
        {data?.newsItemFeed.totalCount
          ? `${data?.newsItemFeed.totalCount}건`
          : ``}
      </SearchResultHeader>
      <NewsList
        data={data?.newsItemFeed.edges || []}
        loading={loading}
        skeletonSize={3}
      />
      {(data?.newsItemFeed.totalCount || 0) > 3 && (
        <Link
          href={{
            query: {
              ...router.query,
              tab: 'news',
            },
          }}
        >
          <a className="more-button last">소식 검색결과 모두 보기</a>
        </Link>
      )}
    </StyledWrapper>
  )
}

export default ChannelSearchAll

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  .more-button {
    display: flex;
    justify-content: center;
    padding: 20px;
    background-color: #e9ecf0;
    cursor: pointer;
    &.last {
      margin-bottom: 40px;
    }
  }
`
